import { LoaderFunctionArgs, Outlet } from 'react-router';

import { TCustomRouteObject, THandle } from '@/shared/types/router.types';
import { DocumentFragment } from '@/shared/types/types.generated';

export const documentInnerRoutes: TCustomRouteObject[] = [
  {
    path: ':documentId/:tabId?',
    lazy: async () => {
      const { Document } = await import('./document');
      return { Component: Document };
    },
    shouldRevalidate: () => false,
    loader: async (args: LoaderFunctionArgs) => {
      const { documentLoader } = await import('./document');
      return documentLoader(args);
    },
    handle: {
      crumb: {
        label: (data: DocumentFragment) => data.name,
      },
    },
  },
];

export const documentsRouteHandle: THandle = {
  crumb: {
    label: 'documents',
    localized: true,
  },
  permission: { action: 'document:readDocument' },
};

export const documentsRoutes: TCustomRouteObject = {
  path: '/documents',
  Component: () => <Outlet />,
  handle: documentsRouteHandle,
  children: [
    {
      index: true,
      lazy: async () => {
        const { DocumentsListRoute } = await import('./documents-list');
        return { Component: DocumentsListRoute };
      },
    },
    ...documentInnerRoutes,
  ],
};
